import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ValuePropositions } from '../components/ValuePropositions';
import { ClassFormats } from '../components/ClassFormats';
import { WhyDesertSage } from '../components/WhyDesertSage';
import { Testimonials } from '../components/Testimonials';
import { SupportCTA } from '../components/SupportCTA';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-white" data-id="element-227">
      <Header data-id="element-228" />
      <main data-id="element-229">
        <Hero data-id="element-230" />
        <ValuePropositions data-id="element-231" />
        <ClassFormats data-id="element-232" />
        <WhyDesertSage data-id="element-233" />
        <Testimonials data-id="element-234" />
        <SupportCTA data-id="element-235" />
      </main>
      <Footer data-id="element-236" />
    </div>;
}